import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';

@Component({
    selector: 'internal-matrix-edit',
    templateUrl: './internal-matrix-edit.html',
})
export class InternalMatrixEditComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;        
    nameValueFields: Object = { text: 'Name', value: 'Value' };    

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {
        this.load(this.id);
    }

    load(id: number) {
        this.http.get(`api/Util/GetInternalMatrix/${id}`, res => {
            this.item = res.Result;            
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.UserName == null) {
            msg = 'User code is required'
        } else if (this.item.UserNameInternal == null) {
            msg = 'Internal code is required'
        }
        return msg;
    }

    onSave() {
        let err = this.isInputValid();
        if (err == null) {            
            this.http.save('api/Util/SaveInternalMatrix', this.item, res => {
            });
        } else {
            this.helper.alertFailed(err);
        }
    }
}
